<script setup>
import { isString } from 'radash'
import InlineSvg from 'vue-inline-svg'

defineProps({
  message: {
    type: String,
    default: '',
    required: true
  }
})
</script>

<template>
  <div
    v-show="isString(message) && message.length > 0"
    class="flex gap-1 font-mono text-red-500 text-sm">
    <InlineSvg
      class="w-4 h-4 shrink-0 mt-1"
      :src="require('@/assets/fontawesome/regular/circle-exclamation.svg')"/>

    <span class="first-letter:uppercase leading-6">{{ message }}</span>
  </div>
</template>
